import * as yup from 'yup'

export const insuranceProductFormValidator = yup.object({
  name: yup.string().trim().required('Product name is required'),
  // Both optional, matching `@IsOptional @IsString` on AdminInsuranceProductCreateDto.
  description: yup.string().trim(),
  explanation: yup.string().trim(),
})
